module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/icon-menu-e57ca5aac6f37b9202f0fecdef3367b8.png";